// Privates local storage
const localStorageGetObject = key => JSON.parse(localStorage.getItem(key));
const localStorageSetItem = (key, value) => localStorage.setItem(key, JSON.stringify(value));
const localStorageRemoveItem = key => localStorage.removeItem(key);
// Local Storage
export const lsGetProspectGuid = () => localStorageGetObject('prospect:guid');
export const lsSetProspectGuid = value => localStorageSetItem('prospect:guid', value);
export const lsRemoveProspectGuid = () => {
  localStorageRemoveItem('prospect:guid');
};

export const lsGetAct = () => localStorageGetObject('act');
export const lsSetAct = value => localStorageSetItem('act', value);
export const lsRemoveAct = () => {
  localStorageRemoveItem('act');
};

export const lsGetGiver = () => localStorageGetObject('giver');
export const lsSetGiver = value => localStorageSetItem('giver', value);
export const lsRemoveGiver = () => {
  localStorageRemoveItem('giver');
};

export const lsGetCifConcession = () => localStorageGetObject('cifConcession');
export const lsSetCifConcession = value => localStorageSetItem('cifConcession', value);
export const lsRemoveCifConcession = () => {
  localStorageRemoveItem('cifConcession');
};
